module.exports = __webpack_public_path__ + "img/concrete-hole-decal-06.5c1a541a.png";